import { useState } from 'react';
import { supabase } from '@/lib/supabaseClient';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleReset = async () => {
    setError('');
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://www.officialscoring.com/resetpassword'
    });

    if (error) {
      setError('Failed to send reset email. Please try again.');
    } else {
      setSubmitted(true);
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto mt-16 border rounded shadow">
      <h1 className="text-xl font-semibold mb-4">Reset your password</h1>
      {submitted ? (
        <p className="text-green-700">
          Check your email for a link to reset your password. Emails may take a few minutes to come through to your inbox.
        </p>
      ) : (
        <>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border p-2 w-full mb-4 rounded"
          />
          <button
            onClick={handleReset}
            className="bg-[#30702F] text-white px-4 py-2 rounded w-full"
          >
            Send reset link
          </button>
          {error && <p className="text-red-600 mt-2">{error}</p>}
        </>
      )}
    </div>
  );
}